<template>
  <section id="actualitees" class="py-20 bg-white">
    <div id="ExcellenceMedicale" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Actualité Scientifiques
        </h2>
        <p class="text-xl text-gray-600 max-w-3xl mx-auto">
          Participez à nos congrès, formations et événements dédiés à
          l'excellence médicale
        </p>
      </div>

      <div class="grid md:grid-cols-2 gap-8">
        <div
          v-for="item in data"
          :key="item.title"
          :class="`bg-gradient-to-r from-${item.color}-50 to-blue-50 rounded-xl overflow-hidden border border-${item.color}-100`"
        >
          <div class="p-4 sm:p-8">
            <div class="flex items-start justify-between mb-4">
              <div>
                <div
                  :class="`bg-${item.color}-600 text-white px-3 py-1 rounded-full text-sm font-semibold mb-2`"
                >
                  {{ item.date }}
                </div>
                <h3 class="text-2xl font-bold text-gray-900">
                  {{ item.title }}
                </h3>
              </div>
              <div class="text-3xl">{{ item.icon }}</div>
            </div>

            <a
              v-if="firstVideoThumb(item)"
              :href="`/actualites/${item.slug || item.id}`"
              class="relative block aspect-video bg-black overflow-hidden group rounded-lg mb-4"
            >
              <img
                :src="firstVideoThumb(item)"
                :alt="item.title"
                class="w-full h-full object-cover"
              />
              <div
                class="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition"
              ></div>
              <div class="absolute inset-0 flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class="w-16 h-16 text-white opacity-95 drop-shadow-lg"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </a>
            <p v-else class="text-gray-600 mb-4">
              {{ item.sub_description }}...
              <a
                :href="`/actualites/${item.slug || item.id}`"
                style="text-decoration: underline"
                >Lire la suite</a
              >
            </p>

            <div class="flex items-center text-sm text-gray-500">
              <svg
                class="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              {{ item.lieu }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-center mt-8" v-if="loading">
        <div
          class="w-12 h-12 border-4 border-blue-500 border-t-transparent border-solid rounded-full animate-spin"
        ></div>
      </div>
      <div v-if="allactualites.length > start" class="text-center mt-8">
        <a
          @click="newActualite"
          class="inline-block px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition"
        >
          Voir plus
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { youtubeThumbnail } from "../utils/youtube";

export default {
  name: "Actualites",
  data() {
    return {
      actualites: [],
      step: 2,
      start: 4,
      loading: false,
      data: [],
      allactualites: this.actualites ?? [],
    };
  },
  mounted() {
    this.fetchActualites();
  },
  methods: {
    newActualite: function () {
      this.loading = true;
      setTimeout(() => {
        this.start = this.start + this.step;
        this.data = this.allactualites.slice(0, this.start);
        this.loading = false;
      }, 1200);
    },

    chargeActualiteProps: function () {
      this.allactualites = this.actualites;
      this.data = this.actualites.length > 0 ? this.actualites.slice(0, 4) : [];
    },

    firstVideoThumb(item) {
      const url = item?.videos?.[0]?.url;
      return url ? youtubeThumbnail(url, "hqdefault") : null;
    },
    async fetchActualites() {
      this.loadingList = true;
      try {
        console.log(`Host server node : ${process.env.VUE_APP_HSERVER_URL}`);
        const res = await fetch(
          `${process.env.VUE_APP_HSERVER_URL}/api/actualites`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        this.actualites = await res.json();
        this.chargeActualiteProps();
      } catch (err) {
        this.formError = "Erreur de chargement";
      } finally {
        this.loadingList = false;
      }
    },
  },
};
</script>
